import { Skeleton } from '@ui/v2/Skeleton'

import { Box } from '@shared/components/Box'

interface InstrumentSkeletonRowsProps {
  count?: number
}

export const InstrumentSkeletonRows: React.FC<InstrumentSkeletonRowsProps> = ({ count = 11 }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <Box key={i} flex align='center' justify='space-between' p='x8' gap='x8'>
        <Skeleton width='40%' height={16} variant='rounded' />
        <Skeleton width='40%' height={16} variant='rounded' />
      </Box>
    ))}
  </>
)
